import {
  ref,
  toRef,
} from "vue";
import {
  useRouter,
} from "vue-router";

import {
  getUrlParams,
  setUrlWithParams,
} from "aloha-vue/src/compositionAPI/AHttpAPI.js";

export default function UrlBrowserAPI(props, {
  initFilterModelFromUrl = () => {},
  initPaginationFromUrl = () => {},
  initSorting = () => {},
}) {
  const isSimpleTable = toRef(props, "isSimpleTable");
  const urlUpdate = toRef(props, "urlUpdate");

  const $router = useRouter();
  const blockFirstLoad = ref(undefined);
  const urlParams = ref({});

  const checkBlockFirstLoad = ({ urlParams }) => {
    if (urlParams?.blockFirstLoad) {
      blockFirstLoad.value = true;
    }
  };

  const initParamsFromUrlBrowser = () => {
    if (!urlUpdate.value || isSimpleTable.value) {
      return;
    }
    urlParams.value = getUrlParams({ keysCommaToArray: ["ordering"] }) || {};
    checkBlockFirstLoad({ urlParams: urlParams.value });
    initFilterModelFromUrl({ urlParams: urlParams.value });
    initPaginationFromUrl({ urlParams: urlParams.value });
    initSorting({ ordering: urlParams.value?.ordering, filtersPropsAndFromAPI: "Url" });
  };

  const changeUrlBrowser = model => {
    if (!urlUpdate.value) {
      return;
    }
    const url = setUrlWithParams({ params: model });

    let currentPath = $router.currentRoute.value.href;
    if (currentPath.indexOf("/") === 0) {
      currentPath = currentPath.slice(1);
    }
    currentPath = currentPath.split("?")[0];
    history.replaceState({}, "", `${ $router.options.base || "/" }${ currentPath }${ url ? "?" + url : "" }`);
  };

  return {
    blockFirstLoad,
    changeUrlBrowser,
    initParamsFromUrlBrowser,
    urlParams,
  };
}
